import * as React from 'react';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import CustomTable from '../../components/atoms/Table'
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Box, Button, IconButton, Paper, Switch, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ActionMenu from 'admin/components/atoms/ActionButton';
import service from '../../api/services';
import toast from 'react-hot-toast';
import SoftButton from 'components/SoftButton';
import { useAuth } from 'AuthContext';


const User = () => {
  const navigate = useNavigate()
  const [ isApiLoading , setIsApiLoading ] = React.useState(true)
  const [data, setData] = React.useState([]);
  const [search, setSearch] = React.useState('');
  const [page, setPage] = React.useState(1);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [sortValue, setSortValue] = React.useState({sortKey:'name',sortDirection:'asc'});
  const columns = [
    { id: 'name', isSorting: true,sortDirection:'asc',label: 'Name' },
    {
      id: 'category', isSorting: true,sortDirection:'asc',label: 'Category',
      render: (row) => {
        return <span>{row?.categories && row?.categories?.map((item) => item.name)?.join(', ')  || "N/A"}</span>;
      }
    },
    {
      id: 'action',
      label: 'Action',
      render: (row) => (

        <>
          <ActionMenu
            items={[
              { label: 'Edit', onClick: () => { navigate(`/admin/edit-keywords/${row._id}`) } },
              { label: 'Delete', onClick: () => { deleteKeyword(row._id) } },
            ]}
          />
        </>
      ),
    },
  ];
const deleteKeyword = async (id) => {
  try {
    const response = await service.keywords.delete(id);

    if ([200, 201].includes(response.status)) {
      toast.success(response.message || 'Keyword deleted successfully.');
      getUserDetail();
    } else {
      toast.error(response.message || 'Failed to delete keyword.');
    }
  } catch (error) {
    const errorMessage = error?.response?.data?.message || 'An error occurred while deleting the keyword.';
    toast.error(errorMessage);
    console.error('Deletion error:', error);
  }
};


  const getUserDetail = async () => {
    setIsApiLoading(true)
    try {
      const response = await service.keywords.view({ searchData: search, page, limit: rowsPerPage,sortKey:sortValue.sortKey ,sortDirection:sortValue.sortDirection });
      if (response?.data?.data) {
        setData(response.data);
      }
    } catch (error) {
      console.error("Failed to fetch business users", error);
    }
      setIsApiLoading(false)
  };

  React.useEffect(() => {
    getUserDetail();
  }, [search, page, rowsPerPage,sortValue]);



  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Paper className='glassmorphism-card' sx={{ padding: 2, mt: '15px' }}>
        <Box display="flex" alignItems="center" justifyContent={'end'}>
          <SoftButton  variant="gradient" color="info" onClick={() => navigate('/admin/add-keywords')}>Add</SoftButton>
        </Box>
        <CustomTable
          title="Keywords List" columns={columns}
          rows={data?.data}
          search={search}
          setSearch={setSearch}
          page={page}
          setPage={setPage}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
          isApiLoading={isApiLoading}
          totalPages={data?.pagination?.totalItems}
          onRequestSort={(id, direction) => {
            setSortValue({sortKey:id,sortDirection:direction})

          }}
        />
      </Paper>
    </DashboardLayout>
  );
}

export default User
